import { LogUserInResponse } from "@/services/ClientInterfaces";
import { defineStore } from "pinia";


const LocalStorageKeyName = "ib:crs";

export const loginStore = defineStore("loginStore", {
    state: () => {
        return {
            authenticated: false,
            details: null as (LogUserInResponse | null)
        };
    },
    actions: {
        logIn(details: LogUserInResponse) {
            this.authenticated = true;
            this.details = details;

            localStorage.setItem(LocalStorageKeyName, JSON.stringify(details));
        },

        logOut() {
            this.authenticated = false;
            this.details = null;

            localStorage.removeItem(LocalStorageKeyName);
        },

        initialize() {
            const storedDetails = localStorage.getItem(LocalStorageKeyName)
                ? JSON.parse(localStorage.getItem(LocalStorageKeyName) as string)
                : null;

            if (storedDetails) {
                this.logIn(storedDetails);
            }

        }
    }
});
